import { Group, GroupProps as MantineGroupProps } from "@mantine/core"

import { Button, ButtonProps } from "../../../atoms/Button/Button"

export type FloatingButtonProps = ButtonProps & {
  onClick: () => void
  tooltip: string
  label: string
  bottom?: number | string
  size?: ButtonProps["size"]
  variant?: ButtonProps["variant"]
  groupProps?: MantineGroupProps
}

export const FloatingButton = ({
  onClick,
  tooltip,
  label,
  bottom = 0,
  size = "sm",
  variant = "primary",
  groupProps,
  ...props
}: FloatingButtonProps) => {
  return (
    <Group
      justify="center"
      w="100vw"
      h="6rem"
      align="center"
      bottom={bottom}
      left="0"
      py="sm"
      style={{ zIndex: 100, pointerEvents: "none" }}
      pos="fixed"
      {...groupProps}
    >
      <Button
        variant={variant}
        size={size}
        onClick={onClick}
        toolTip={tooltip}
        style={{
          borderRadius: "var(--mantine-radius-md)",
          pointerEvents: "auto",
        }}
        {...props}
      >
        {label}
      </Button>
    </Group>
  )
}
